import { useContext } from 'react'

import {
  GlobalTextContext,
  IGlobalTextContext,
} from '@system/providers/globalTextProvider'

export default function useGlobalText(): IGlobalTextContext {
  const { getText } = useContext(GlobalTextContext)

  return { getText }
}
